// @react
import React from 'react'
import { ReactElement } from 'react'
// @components
import SkeletonLoader from '@bit/atd.web.loaders.skeleton'
import NetworkActivityCard from '../NetworkActivityCard'
import RecommendedUsersCard from '../RecommendedUsersCard'
// @graphql
import {
  GetNetworkSummaryQuery,
  GetNetworkSummaryQueryVariables,
  GetUserNetworkActivityQuery,
  GetUserNetworkActivityQueryVariables,
  NetworkActivityOrderByList,
} from 'lib/graphql/graphqlTypes'
import { useQuery } from '@apollo/client'
import {
  GET_NETWORK_USERS_SUMMARY,
  GET_USER_NETWORK_ACTIVITY,
} from 'graphql/queries/userNetwork.query'
import QueryError from 'modules/common/components/Errors/QueryError'

// ActionType.JOINED_BY
// ActionType.REQUESTED
// ActionType.JOINED_TO
// ActionType.REJECTED
// ActionType.PENDING

/**
 * 2.0.0.9 MyATD - Dashboard - Network
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 */

/**
 *
 * @constructor
 */
const Network = (): ReactElement => {
  /******************************************
   * GQL HOOKS
   ******************************************/
  const {
    loading: isActivityLoading,
    error: isActivityError,
    data: activityData,
  } = useQuery<
    GetUserNetworkActivityQuery,
    GetUserNetworkActivityQueryVariables
  >(GET_USER_NETWORK_ACTIVITY, {
    variables: {
      input: {
        page: 1,
        pageSize: 5,
        orderBy: {
          value: NetworkActivityOrderByList.CREATED_DATE,
        },
      },
    },
    fetchPolicy: 'cache-first',
  })

  const {
    loading: isNetWorkUsersSummaryLoading,
    error: isNetWorkUsersSummaryError,
    data: networkSummaryData,
  } = useQuery<GetNetworkSummaryQuery, GetNetworkSummaryQueryVariables>(
    GET_NETWORK_USERS_SUMMARY,
    {
      fetchPolicy: 'cache-first',
    },
  )

  /******************************************
   * RENDER
   ******************************************/
  const isLoading = isActivityLoading || isNetWorkUsersSummaryLoading
  const isError = !!(isActivityError || isNetWorkUsersSummaryError)
  const isActivityData = activityData?.activity?.meta?.count !== 0

  if (isError) {
    return <QueryError />
  }

  if (isLoading) {
    return <SkeletonLoader />
  }

  return isActivityData ? (
    <NetworkActivityCard
      activityItems={activityData?.activity.data}
      followingCount={networkSummaryData?.publicUsersFollowing.meta?.count}
      followedCount={networkSummaryData?.publicUsersFollowed.meta?.count}
      groupsCount={networkSummaryData?.userGroups.meta?.count}
    />
  ) : (
    <RecommendedUsersCard />
  )
}

export default Network
